import React from 'react';

const STAGES = ['Received', 'Processing', 'Shipped', 'Delivered'];

export default function PipelineWidget({ pipeline }) {
  return (
    <div className="bg-white rounded-2xl shadow p-4 mb-4">
      <h2 className="text-xl font-bold mb-2">Production Pipeline</h2>
      <div className="grid grid-cols-4 gap-4">
        {STAGES.map((stage, idx) => (
          <div key={stage} className="flex flex-col items-center">
            <span className="font-semibold">{stage}</span>
            <span className="text-2xl">{pipeline[stage] || 0}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
